module.exports = [
  { id: '1', name: 'クレンジング', code: 'cleansing' },
  { id: '2', name: '洗顔', code: 'facewash' },
  { id: '3', name: '化粧水', code: 'losion' },
  { id: '4', name: '乳液・クリーム', code: 'milk' },
  { id: '5', name: 'スペシャルケア', code: 'special_care' },
  { id: '6', name: 'blank', code: 'blank'}
]
